<template>
  <div :class="[
      s.wrap,
      s[helper.displayDirection],
      `history_${helper.displayDirection}`,
      'history',
    ]">
    <Loader :flag="true" v-if="flag.loading.get"/>
    <div :class="s.content" v-else>
      <div v-if="!reservations.length" class="p-3 fw-bold">
        <div><i class="fa-solid fa-volume me-3" />現在、履歴はありません。</div>
      </div>
      <swiper
        ref="order-slide"
        v-if="reservations.length && flag.showSlider" :slides-per-view="1"
        :space-between="0"
        :modules="modules"
        :pagination="false"
        :navigation="true"
        :centered-slides="true"
        :initial-slide="isShowIdx"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        :class="s.card_container">
        <swiper-slide v-for="reservation in reservations" :key="reservation.id" :class="s.slide">
          <component
            :is="reservation.foreign_type === 31 ? 'HistoryDemand' : 'HistoryDefault'"
            :reservation="reservation"
            :styleClasses="s" />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
import moment from 'moment';
import cf from '@/mixins/commonFunctions';
import {
  HistoryDemand,
  HistoryDefault,
  Loader,
} from '@/components/parts';

export default {
  name: 'history',
  mixins: [cf],
  components: {
    Swiper,
    SwiperSlide,
    HistoryDemand,
    HistoryDefault,
    Loader,
  },
  data() {
    return {
      flag: {
        showSlider: true,
        loading: {
          get: false,
        },
      },
      reservations: [],
      isShowIdx: 0,
    };
  },
  computed: {
    ...mapState(['user', 'helper', 'modal']),
  },
  setup() {
    return {
      modules: [Pagination, Navigation],
    };
  },
  created() {
    this.getHistory();
  },
  watch: {
    'modal.contents.updateData': {
      handler(val) {
        if (val.data?.type === 'orderResultUpdate') {
          this.getHistory();
        }
      },
      deep: true,
    },
  },
  methods: {
    async getHistory() {
      this.flag.loading.get = true;
      const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
      const today = moment().format('YYYY-MM-DD');
      const params = {
        driver_id: this.user.id,
        startDateTime: `${yesterday} 15:00:00`,
        endDate: today,
        isCompletedFlags: ['complete'],
        order: 'desc',
        orderBy: 'rsvDatetime',
      };
      await this.axios({
        method: 'get',
        url: '/v1/reservation/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          // template側の整備が済んでいないのでデマンド除いている
          this.reservations = res.reservations.data;
          if (this.$route.query?.code) {
            const idx = this.reservations.findIndex((rsv) => rsv.code === this.$route.query.code);
            this.isShowIdx = idx || 0;
          }
        });
      this.flag.loading.get = false;
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },
    changeIsShowIdx(type) {
      if (type === 'back' && this.isShowIdx > 0) this.isShowIdx -= 1;
      if (type === 'next' && this.isShowIdx < this.reservations.length - 1) this.isShowIdx += 1;
    },
  },
};
</script>
<style lang="scss">
.history {
  .swiper-button-prev, .swiper-button-next {
    bottom: 0; top: auto;
    width: 60px;
    height: 100%;
    border-radius: 4px;
    background-color: var(--bs-gray);
    border: none;
    &::after {
      font-size: 30px;
      color: #ffffff;
    }
  }
  .swiper-button-next {
    right: 0px;
  }
  .swiper-button-prev {
    left: 0px;
  }
  .swiper-button-disabled {
    opacity: 1;
    background-color: #dce1e5;
    border-color: rgba(#ffffff, .1) rgba(#000000, .05) rgba(#000000, .05) rgba(#ffffff, .1);
  }
  .swiper-button-lock {
    display: flex;
  }
}

.history_vertical {
  .swiper-button-prev, .swiper-button-next {
    bottom: 0; top: auto;
    width: 50%;
    height: 60px;
    &::after {
      font-size: 30px;
      color: #ffffff;
    }
  }
}
</style>

<style lang="scss" module="s">
.wrap {
  height: 100%;
  .content {
    height: 100%;
  }
}

.card_container {
  padding: 0 60px;
  height: 100%;
  .slide {
    height: 100%;
  }
}

.card {
  height: 100%;
  // box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  // border-radius: 8px;
  display: flex;
  flex-direction: column;
  // border: 1px solid var(--border-gray);
  &_header {
    border-bottom: 1px solid var(--border-gray);
    padding: 4px 12px;
    background-color: var(--bg-gray);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }
  &_body {
    flex: 1;
    padding: 0 12px;
    overflow: scroll;
    background-color: #ffffff;
    &_content {
      height: 100%;
      overflow: scroll;
    }
  }
}

.reservation {
  position: relative;
  height: fit-content;
  display: flex;
  padding-top: 12px;
  > :nth-child(1) {
    flex: 1;
  }
  > :nth-child(2) {
    width: 150px;
    display: flex;
    flex-direction: column;
    > :not(:first-child) {
      margin-top: 6px;
    }
  }
}

.item {
  width: 100%;
  text-align: left;
  border-radius: 4px;
  margin-bottom: 12px;
  > :nth-child(1) {
    display: flex;
    align-items: center;
    background-color: var(--bg-gray);
    padding: 2px 8px;
    > * {
      font-weight: bold;
    }
  }
  > :nth-child(2) {
    padding: 0 8px;
    margin-top: 8px;
    flex: 1;
  }
}

.revisions {
  margin-left: 0;
}

// windowサイズが縦長の時
.wrap.vertical {
  .content {}
  .card_container {
    padding: 0  0 60px 0;
  }
  .reservation {
    flex-direction: column;
  }
}
.buttons {
  height: 100%;
  button {
    border: none;
    background-color: transparent;
    padding: 0 16px;
    font-weight: bold;
    border-radius: 4px;
    &.blue {
      background-color: var(--bs-blue);
      color: white;
    }
    &.gray {
      background-color: var(--bs-gray);
      color: white;
    }
    &.green {
      background-color: #20C997;
      color: white;
    }
  }
}
</style>
